import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import gameContext, { game } from './contexts/gameContext';

export default function (modules, config, el, message) {    
  serviceWorker.unregister();
  const game = {
      modules: modules,
      config: config,
      message: message
  }

  ReactDOM.render(
    <React.StrictMode>
      <gameContext.Provider value={game}>
        <App />
      </gameContext.Provider>
    </React.StrictMode>,
    el
  );
}
